import { config } from "config";
import { SetDeliveryCarModelsPayload, DeliveryCarModelState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";

const default_page_size = config.PAGE_SIZE;
const initialState: DeliveryCarModelState = {
  totalCount: 0,
  deliveryCarModels: [],
  deliveryCarModel: null,
  loading: true,
  exportCSVLoading: false,
  refresh: 0,
  refreshLoader: false,
  current_filters: {},
  csvMessage: null,
  deliveryCarModelOptions: [],
  deliveryCarModelOptionsCount: 0,
  deliveryCarModelOptionsFilters: { page: 1, page_size: 30, search: "" },
  filters: { page: 1, pageSize: default_page_size },
};

export const deliveryCarModelSlice = createSlice({
  name: "deliveryCarModel",
  initialState,
  reducers: {
    clear: (state) => {
      state.deliveryCarModelOptions = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setExportCSVLoading: (state, action: PayloadAction<boolean>) => {
      state.exportCSVLoading = action.payload;
    },
    addCarModel: (state, action) => {
      state.deliveryCarModels.unshift(action.payload);
    },
    updateCarModel: (state, action) => {
      const { id, carModel } = action.payload;
      state.deliveryCarModels.every(({ _id }, i) => {
        if (id === _id) {
          state.deliveryCarModels[i] = carModel;
          return false;
        }
        return true;
      });
    },
    deleteCarModelById: (state, action) => {
      const id = action.payload;
      state.deliveryCarModels.every(({ _id }, i) => {
        if (id === _id) {
          state.totalCount -= 1;
          state.deliveryCarModels.splice(i, 1);
          return false;
        }
        return true;
      });
    },
    setCarModel: (state, action) => {
      state.deliveryCarModel = action.payload;
    },
    setCarModels: (
      state,
      action: PayloadAction<SetDeliveryCarModelsPayload>
    ) => {
      const { totalCount, deliveryCarModels } = action.payload;
      state.totalCount = totalCount;
      state.deliveryCarModels = deliveryCarModels;
    },
    setCarModelOptions: (state, action: PayloadAction<SelectOption[]>) => {
      state.deliveryCarModelOptions = action.payload;
    },
    setCarModelOptionsCount: (state, action: PayloadAction<number>) => {
      state.deliveryCarModelOptionsCount = action.payload;
    },
    setCarModelOptionsPage: (state, action: PayloadAction<number>) => {
      state.deliveryCarModelOptionsFilters.page = action.payload;
    },
    setCarModelOptionsSearch: (state, action: PayloadAction<string>) => {
      state.deliveryCarModelOptionsFilters.search = action.payload;
      state.deliveryCarModelOptionsFilters.page = 1; // Reset to first page when searching
    },
    resetCarModelOptionsFilters: (state) => {
      state.deliveryCarModelOptionsFilters =
        initialState.deliveryCarModelOptionsFilters;
    },
    setPage: (state, action: PayloadAction<{ page: number }>) => {
      const { page } = action.payload;
      state.filters.page = page;
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
    setCsvMessage: (
      state,
      action: PayloadAction<{
        message: string;
        type: "success" | "error" | "warning" | "info";
      } | null>
    ) => {
      state.csvMessage = action.payload;
    },
  },
});

const deliveryCarModelReducer = deliveryCarModelSlice.reducer;

export const deliveryCarModelActions = deliveryCarModelSlice.actions;
export default deliveryCarModelReducer;
